<template>
    <div
        class="app content"
        style="background-image: url('img/brand/bg-auth.png')"
    >
        <div class="content-auth">
            <!-- Acceso de Soluquim a Microsoft -->
            <div
                class="d-flex justify-content-between align-items-center pb-2 px-4 header-auth"
            >
                <img
                    src="https://aadcdn.msftauth.net/shared/1.0/content/images/microsoft_logo_564db913a7fa0ca42727161c6d031bef.svg"
                    width="100"
                    height="auto"
                />
            </div>

            <b-alert show dismissible variant="danger" v-if="microsoftOnline.hasErrorInSessionUser">
                {{ microsoftOnline.messageError ? microsoftOnline.messageError : 'Ocurrió un error y no fue posible completar tu solicitud, por favor inténtelo de nuevo o vuelva intentarlo más tarde. Si el error persiste, comunícate con el administrador del sistema.' }}
            </b-alert>

            <!-- Redireccionando -->
            <div class="row justify-content-start mt-5 pl-3 px-5">
                <h5 class="d-flex justify-content-center align-items-center">
                    <small>
                        <i
                            :class="`fa fa-${
                                microsoftOnline.loadingAccessMicrosoftToApp
                                    ? 'spinner fa-spin'
                                    : (microsoftOnline.hasErrorInSessionUser ? 'close' : 'check')
                            } mr-2 color-icon`"
                        ></i>
                        <span
                            :class="
                                microsoftOnline.loadingAccessMicrosoftToApp ? 'text-gray' : ''
                            "
                        >
                            Redireccionando a <strong>Soluquim</strong>
                        </span>
                    </small>
                </h5>
            </div>

            <div class="row justify-content-start mt-2 pl-3 px-5">
                <h5 class="d-flex justify-content-center align-items-center">
                    <small>
                        <i
                            :class="`fa fa-${
                               microsoftOnline.loadingAccessToSoluquim
                                    ? 'spinner fa-spin'
                                    : (microsoftOnline.hasErrorInSessionUser ? 'close' : 'check')
                            } mr-2 color-icon`"
                        ></i>
                        <span
                            :class="microsoftOnline.loadingAccessToSoluquim ? 'text-gray' : ''"
                        >
                            Iniciando sesión
                        </span>
                    </small>
                </h5>
            </div>

            <!-- Problemas (no tiene autorización) -->
            <br />
            <div
                v-if="microsoftOnline.hasErrorInSessionUser"
                class="d-flex justify-content-between align-items-end mt-5 mb-2 pl-3 pr-4"
            >
                <b-button variant="link" @click="onHandleGoBack()" class="px-0 pb-0">
                    Volver a SOLUQUIM
                </b-button>
                <b-button variant="outline-danger" class="ml-2" @click="onHandleReload()">
                    <i class="fa fa-history mr-1"></i>
                    Reintentar
                </b-button>
            </div>

        </div>

        <div>
            <p>
                <small
                    >Este proceso no debería demorar mucho, por favor
                    espera...</small
                >
            </p>
        </div>
    </div>
</template>

<script>

import { mapMutations, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

export default {
    name: "AuthAzure",
    data() {
        return {
            code: null
        };
    },
    mounted() {
        // Acceder al parámetro 'code' de la ruta
        this.code = this.$route.query.code;

        if (this.code) {
            try {
                this.loginLocal();
            } catch (error) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Autenticación de usuarios',
                    text: "No fue posible completar el proceso, intentelo más tarde.",
                    showConfirmButton: true
                })
            }
        }
    },
    computed: {
        ...mapState("autenticacion", ["microsoftOnline"])
    },
    methods: {
        ...mapActions("autenticacion", ["authenticationAzure"]),

        async loginLocal() {
            await this.authenticationAzure({
                code: this.code,
                router: this.$router
            });
        },
        onHandleGoBack() {
            window.location.assign(process.env.VUE_APP_APP)
        },
        onHandleReload() {
            window.location.assign(`${process.env.VUE_APP_APP}/#/login.microsoftonline.com:${localStorage.getItem("login.microsoft.online-CCN") || null}`)
        }
    },
};
</script>

<style scope>
.content {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.header-auth {
    background-color: #ececec;
    height: 100px;
}

.color-icon {
    color: #375b96;
}

.text-gray {
    color: rgb(163, 163, 163);
}

.content-auth {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    max-width: 440px;
    width: calc(100% - 40px);
    margin-bottom: 28px;
    background-color: #fff;
    -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    min-width: 320px;
    min-height: 338px;
    overflow: hidden;
}
</style>
